import React, {  useEffect, useCallback } from 'react';
import { useParams } from "react-router-dom";
import { global_var } from '../../services/cs-lab-config';
import IdeHeader from "./ide-header";
import {  Button } from "antd";

const MakeCodeIde = () => {

    let { ideProjectId } = useParams();

    document.title = "CS Lab | MakeCode";

    const openMakeCode =  useCallback((projectId) => {
      // const userToken = localStorage.getItem("token");
      const userToken = sessionStorage.getItem('token');
      let iframeUrl = global_var.MAKECODE_ENDPOINT + "?token=" + userToken + '#editor';

      if(projectId){
        iframeUrl = global_var.MAKECODE_ENDPOINT + "?token=" + userToken + "&lmsProjectId=" + projectId+ "#editor"
      }

      window.open(iframeUrl);
    },[]);

    useEffect(() => {
      if(ideProjectId){
        openMakeCode(ideProjectId)
      } else {
        openMakeCode(undefined)
      }
    },[ideProjectId, openMakeCode])

    return (
        <div className="container-fluid p-0">
            <div className="row">
                <div className="col">
                    <IdeHeader
                        headerName="MakeCode"
                    />
                </div>
            </div>

            <div className="row">
              <div className="col">
              <Button
                type={ "primary"}
                style={{ marginRight: "8px" }}
                onClick={()=>{
                  openMakeCode(undefined)
                }}
              >
                Click here to create new project
              </Button>
              </div>
            </div>
        </div>
    );
  };
export default MakeCodeIde;